<template>
  <div v-if="!disabled" class="tooltip">
    <NsIcon
      class="top-arrow"
      icon-name="icon-top-arrow-with-shadow-24"
      size="custom"
    />
    <div class="tooltip-box">
      <p class="tooltip-paragraph">{{ message }}</p>
      <div class="tooltip-icon-close" @click.stop="$emit('close', $event)">
        <NsIcon class="icon-close" icon-name="icon-close" size="custom" />
      </div>
    </div>
  </div>
</template>

<script>
import { NsIcon } from "@nuskin/design-components";

export default {
  name: "NsSearchbarTooltip",
  components: { NsIcon },
  props: {
    disabled: Boolean,
    message: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/other";

.tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  display: block;
  margin: 0 auto;
  transition: map.get(other.$otherUtils, global-transition);
  z-index: 999;
}

.top-arrow {
  position: absolute;
  right: 0;
  left: 0;
  margin: 0 auto;
  margin-top: 3px;
  width: 24px;
  height: 24px;
  color: white;
  filter: drop-shadow(0px -3px 2px rgba(0, 0, 0, 0.15));
  z-index: calc(#{map.get(other.$otherUtils, z-dropdown)} + 1);
}

.tooltip-box {
  position: absolute;
  left: -100%;
  margin-bottom: 0;
  margin-left: 150%;
  margin-top: 15px;
  padding: 10px 5px;
  padding: 23px 5px 10px;
  width: 145px;
  background-color: white;
  @include global.p-small();
  text-align: center;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
  transform: translateX(-50%);
  z-index: map.get(other.$otherUtils, z-dropdown);
}

.tooltip-paragraph {
  margin: 0;
  color: map.get(colors.$themeColors, color-interactive-7);
  text-transform: none;
  @include global.p-medium();
}

.tooltip-icon-close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 4px;
  height: 22px;
  width: 22px;
  color: map.get(colors.$themeColors, color-interactive-7);
  box-sizing: border-box;
  cursor: pointer;
}

.icon-close {
  height: 100%;
  width: 100%;
}
</style>
